import styled from 'styled-components';

import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';

export const SubmissionSuccess = () => {
  const { t } = useScopedTranslate(translations);
  return (
    <Container>
      <Text font="heading2" text={t('title')} />
      <Text font="regular16" text={t('body')} />
    </Container>
  );
};

const translations = {
  en: {
    title: 'Onboarding form received',
    body: 'Thank you for taking the time to complete this important form. We will contact you if we feel we need more information.',
  },
  is: {
    title: 'Svör móttekin',
    body: 'Takk fyrir að taka þér tíma til að fylla út þetta mikilvæga form. Við höfum samband ef við teljum okkur þurfa fleiri upplýsingar.',
  },
  dk: {
    title: 'Onboarding formular modtaget',
    body: 'Tak fordi du tog dig tid til at udfylde denne vigtige formular. Vi kontakter dig hvis vi har brug for mere information.',
  },
};

const Container = styled(Stack).attrs({ space: 4 })({
  textAlign: 'center',
  margin: 'auto',
  width: '100%',
  maxWidth: pxToRem(580),
});
